import React from 'react';
import { BookOpenIcon } from 'lucide-react';
import { motion } from 'framer-motion';
export function Header() {
  return <header className="w-full border-b" style={{
    borderColor: 'var(--color-border)',
    backgroundColor: 'var(--color-cream)'
  }} data-id="element-41">
      <div className="max-w-3xl mx-auto px-4 py-5 flex items-center justify-center gap-3" data-id="element-42">
        <BookOpenIcon className="w-6 h-6" style={{
        color: 'var(--color-brown)'
      }} data-id="element-43" />
        <motion.h1 initial={{
        opacity: 0,
        y: -10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="font-handwritten text-4xl md:text-5xl tracking-wide" style={{
        color: 'var(--color-brown)'
      }} data-id="element-44">
          Napftagebuch
        </motion.h1>
      </div>
      <div className="text-center pb-3" data-id="element-45">
        <p className="text-sm italic" style={{
        color: 'var(--color-text-light)'
      }} data-id="element-46">
          Ehrliche Geschichten aus dem Hundealltag
        </p>
      </div>
    </header>;
}